var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVandrerute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    "data-name": "ICONS",
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    ry: 7.795,
    fill: "#427c7f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m6.074,12.498h-.5c-.083,0-.15.067-.15.15s.067.15.15.15h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.074,12.498h-.5c-.083,0-.15.067-.15.15s.067.15.15.15h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.074,12.498h-.5c-.083,0-.15.067-.15.15s.067.15.15.15h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.074,12.498h-.5c-.083,0-.15.067-.15.15s.067.15.15.15h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.074,12.498h-.5c-.083,0-.15.067-.15.15s.067.15.15.15h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.074,12.498h-.5c-.083,0-.15.067-.15.15s.067.15.15.15h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.074,12.498h-.5c-.083,0-.15.067-.15.15s.067.15.15.15h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.017,12.498h-.442c-.083,0-.15.067-.15.15s.067.15.15.15h.442c.083,0,.15-.067.15-.15s-.067-.15-.15-.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.074,12.498h-.5c-.083,0-.15.067-.15.15s.067.15.15.15h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.557,11.652h-.5c-.083,0-.15.067-.15.15s.067.15.15.15h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.057,11.652c-.083,0-.15.067-.15.15s.067.15.15.15h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15h-.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.057,11.652c-.083,0-.15.067-.15.15s.067.15.15.15h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15h-.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.057,11.952h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15h-.5c-.083,0-.15.067-.15.15s.067.15.15.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.906,11.802c0,.083.067.15.15.15h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15h-.5c-.083,0-.15.067-.15.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.707,11.802c0-.083-.067-.15-.15-.15h-.5c-.083,0-.15.067-.15.15s.067.15.15.15h.5c.083,0,.15-.067.15-.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.057,11.652c-.083,0-.15.067-.15.15s.067.15.15.15h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15h-.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.057,11.952h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15h-.5c-.083,0-.15.067-.15.15s.067.15.15.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.057,11.952h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15h-.5c-.083,0-.15.067-.15.15s.067.15.15.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.557,11.652h-.5c-.083,0-.15.067-.15.15s.067.15.15.15h.5c.083,0,.15-.067.15-.15s-.067-.15-.15-.15Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.385,9.975c-.019.028-.057.092-.063.182-.002.023-.006.116.051.214.057.098.14.14.157.148.122.059.237.029.268.02.114-.034.176-.112.197-.14.411-.533.788-.831,1.199-1.364l.563-.612c.349.214.508.404.508.404.048.515.178.836.226,1.351-.002.035-.002.09.017.154.01.035.036.116.111.185.023.021.126.11.276.097.136-.012.218-.099.242-.125.026-.028.09-.099.1-.205.003-.031,0-.058-.003-.077-.054-.578-.108-1.156-.162-1.735-.002-.027-.007-.061-.02-.1-.018-.055-.045-.096-.065-.122-.333-.416-.391-.666-.724-1.082.053-.413.126-.673.189-1.098.084.113.107.143.109.145.017.023.042.056.081.108.008.027.025.069.06.111.038.046.08.072.105.085.302.141.747.363,1.094.529l-.2,3.46c-.003.055.039.103.094.105.002,0,.004,0,.006,0,.053,0,.097-.041.1-.094l.195-3.382c.035.01.108.027.197-.005.082-.03.127-.084.137-.097.011-.014.051-.067.063-.148.013-.09-.018-.159-.026-.174-.033-.07-.085-.107-.108-.122-.066-.032-.145-.07-.224-.11l.039-.684c.003-.055-.039-.103-.094-.105-.002,0-.004,0-.006,0-.053,0-.097.041-.1.094l-.035.599c-.264-.132-.547-.275-.75-.372-.2-.476-.401-.951-.601-1.427-.015-.043-.046-.118-.114-.191-.025-.027-.09-.09-.194-.131-.141-.055-.266-.035-.319-.023-.114.026-.182.043-.297.141-.375.317-.398.603-.56,1.094-.404,1.393-.33,1.738-.613,3.016-.41.529-.694.954-1.105,1.483Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.474,4.049c.396,0,.717-.321.717-.717s-.321-.717-.717-.717-.717.321-.717.717.321.717.717.717Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.453,6.716l.487.128c.254.067.468-.088.535-.342,0,0,.149-.507.189-.675.149-.623.327-1.048.327-1.115.001-.27-.631-.406-1.022-.276-.299.1-.856,1.7-.856,1.7-.067.254.086.514.34.581Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVandrerute);
export default __webpack_public_path__ + "static/media/VANDRERUTE.636743783a7347e4374d1651fb925a14.svg";
export { ForwardRef as ReactComponent };